class UserContactInfo {
    static get inst() {
        if(!this._inst) {
            this._inst = new UserContactInfo()
        }
        return this._inst
    }

    constructor() {
        try {
            const cached = sessionStorage.contact && sessionStorage.contact.startsWith("{") && JSON.parse(sessionStorage.contact);
            if (cached) {
                this.contact = cached;
                return;
            }
        } catch (e) {
            console.warn('Invalid sessionStorage.contact:', e);
        }

        this.contact = null;

        $.ajax(`/a/userContact/me`).done(c => {
            this.contact = c;
            sessionStorage.contact = JSON.stringify(c);
        }).fail(jqXHR => {
            if (jqXHR.status === 404) {
                this.contact = {
                    avatarUrl: null,
                    company_name: null,
                    email: null,
                    person_name: null,
                };
                sessionStorage.contact = JSON.stringify(this.contact);
            } else {
                this.contact = null;
                delete sessionStorage.contact;
            }
        });
    }

    get contact() {
        return this._contact
    }

    set contact(v) {
        if(v) {
            this._contact = v
            sessionStorage.contact = JSON.stringify(v)
        } else {
            this._contact = null
            delete sessionStorage.contact
        }
    }
}
